<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                                <span>
                                  2 Step Verification
                                </span>
                            </p>
                            <div  v-if="!isSuccess">
                                <button
                                    v-if="!isForcedAccountChangePassword"
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    @click="closeModal"
                                >
                                    <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                                </button>
                            </div>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: hidden">
                                <div v-if="isSuccess" class="text-center">
                                    <span v-if="!isForcedAccountChangePassword">Your {{ factorType }} was changed successfully</span>
                                    <span v-else>Your Password was changed successfully. You will now need to login again.</span>
                                </div>
                                <div v-else>
                                    <div class="row" v-if="!isCodeSent">
                                        <div class="col-md-12 text-center">
                                            <p class="text-secondary text-center font-weight-normal">
                                                Where to do you want us to send the verification code?
                                            </p>
                                            <div class="col-md-12 mt-4">
                                                <div class="list-checbox donation-checkbox" style="cursor: pointer"
                                                     @click="verify_type = 'EMAIL'">
                                                    <div class="checkbox-item pl-5 pr-5">
                                                        <label class="checkbox-custom position-relative">
                                                            <input type="checkbox" :checked="verify_type === 'EMAIL'">
                                                            <span class="checkmark-new"
                                                                  :class="verify_type === 'EMAIL' ? 'active' : 'not-active'"></span>
                                                        </label>
                                                        <p :class="verify_type === 'EMAIL' ? 'active' : ''">Email:
                                                            <strong class="d-inline">{{ data.email }}</strong></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="list-checbox donation-checkbox" style="cursor: pointer"
                                                     @click="verify_type = 'PHONE'">
                                                    <div class="checkbox-item pl-5 pr-5">
                                                        <label class="checkbox-custom position-relative">
                                                            <input type="checkbox" :checked="verify_type === 'PHONE'">
                                                            <span class="checkmark-new"
                                                                  :class="verify_type === 'PHONE' ? 'active' : 'not-active'"></span>
                                                        </label>
                                                        <p :class="verify_type === 'PHONE' ? 'active' : ''">Phone:
                                                            <strong class="d-inline">{{ data.phone_num }}</strong></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row text-center" v-else>
                                        <div class="col-md-12">
                                            <div class="mt-4">
                                                <p class="text-center">
                                                    <span>Enter the code you received to your <span
                                                        v-text="verify_type === 'EMAIL' ? 'email' : 'phone'"/></span>
                                                </p>
                                                <div class="d-flex justify-content-center">
                                                    <div class="form-box otp-input-wrap">
                                                        <input
                                                            ref="otp1"
                                                            :disabled="!isCodeSent"
                                                            v-model="otpCode[1]"
                                                            @keydown="handleKeyDown($event, 1)"
                                                            type="text" maxlength="1" id="otp" placeholder=""
                                                            class="otp-input"/>
                                                    </div>
                                                    <div class="form-box ml-2 otp-input-wrap">
                                                        <input
                                                            ref="otp2"
                                                            :disabled="!isCodeSent"
                                                            @keydown="handleKeyDown($event, 2)"
                                                            v-model="otpCode[2]" type="text" maxlength="1" id="otp"
                                                            placeholder="" class="otp-input"/>
                                                    </div>
                                                    <div class="form-box ml-2 otp-input-wrap">
                                                        <input
                                                            ref="otp3"
                                                            :disabled="!isCodeSent"
                                                            @keydown="handleKeyDown($event, 3)"
                                                            v-model="otpCode[3]" type="text" maxlength="1" id="otp"
                                                            placeholder="" class="otp-input"/>
                                                    </div>
                                                    <div class="form-box ml-2 otp-input-wrap">
                                                        <input
                                                            ref="otp4"
                                                            :disabled="!isCodeSent"
                                                            @keydown="handleKeyDown($event, 4)"
                                                            v-model="otpCode[4]" type="text" maxlength="1" id="otp"
                                                            placeholder="" class="otp-input"/>
                                                    </div>
                                                    <div class="form-box ml-2 otp-input-wrap">
                                                        <input
                                                            ref="otp5"
                                                            :disabled="!isCodeSent"
                                                            @keydown="handleKeyDown($event, 5)"
                                                            v-model="otpCode[5]" type="text" maxlength="1" id="otp"
                                                            placeholder="" class="otp-input"/>
                                                    </div>
                                                    <div class="form-box ml-2 otp-input-wrap">
                                                        <input
                                                            ref="otp6"
                                                            :disabled="!isCodeSent"
                                                            @keydown="handleKeyDown($event, 6)"
                                                            v-model="otpCode[6]" type="text" maxlength="1" id="otp"
                                                            placeholder="" class="otp-input"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 text-center" v-if="isCodeSent">
                                                <span v-if="intervalResendCode > 0"> Resend code in {{
                                                        intervalResendCode
                                                    }}s</span>
                                                <a v-else href="javascript:;" class="text-secondary"
                                                   @click="resendCode">
                                                    Resend code now
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-4" v-if="!isSuccess">
                                    <button v-text="'Send Code'"
                                            v-if="!isCodeSent"
                                            class="btn-dialog btn-sm ok-btn mr-2" @click="performSendOtp">
                                    </button>
                                    <button v-text="'Verify Code'"
                                            v-if="isCodeSent"
                                            :disabled="!codeEntered"
                                            class="btn-dialog btn-sm ok-btn mr-2" @click="performVerificationOtp">
                                    </button>
                                </div>
                                <div class="d-flex justify-content-center mt-4" v-else>
                                    <button v-text="'Done'"
                                            class="btn-dialog btn-sm ok-btn mr-2" @click="finish">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import DibbleJS from "@/dibble";
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";

export default {
    name: "ModalAccount2StepVerifyProgress",
    props: {
        data: Object,
        factorType: String,
    },
    data() {
        return {
            verify_type: 'EMAIL',
            isSuccess: false,
            intervalResendCode: 30,
            isCodeSent: false,
            otpCode: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
            },
        };
    },
    computed: {
        codeEntered() {
            let isEntered = true;
            for (let i = 1; i <= 6; i++) {
                if (!this.otpCode[i]) {
                    isEntered = false;
                    break;
                }
            }

            return isEntered;
        },
        isVerified() {
            return this.userData && this.userData.is_phone_verified && this.userData.is_email_verified;
        },
        isOwner() {
            return this.$cookies.get("_user").is_owner;
        },
        isForcedAccountChangePassword() {
            return this.$cookies.get("_user").need_change_password;
        }
    },
    watch: {
        otpCode: {
            handler: function (val) {
                if (val[6]) {
                    this.$refs.otp6.blur();
                } else if (val[5]) {
                    this.$refs.otp6.focus();
                } else if (val[4]) {
                    this.$refs.otp5.focus();
                } else if (val[3]) {
                    this.$refs.otp4.focus();
                } else if (val[2]) {
                    this.$refs.otp3.focus();
                } else if (val[1]) {
                    this.$refs.otp2.focus();
                }
            },
            deep: true,
        },
    },
    methods: {
        performSendOtp() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner
                    ? DibbleApi.api.accountChangeFactorSendOtpCode
                    : DibbleApi.api.managedUserChangeFactorSendOtpCode
                ,
                second_factor_key: this.data.second_factor_key,
                factor_type: this.verify_type.toUpperCase(),
            };

            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    DibbleJs.toastSuccessMessage(
                        'Verification code sent successfully'
                    );

                    this.isCodeSent = true;
                    this.startResendCodeInterval();

                    setTimeout(() => {
                        this.$refs.otp1.focus();
                    }, 500);
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        finish() {
            this.$emit('finish', this.isForcedAccountChangePassword)
        },
        startResendCodeInterval() {
            this.intervalResendCode = 30;
            const interval = setInterval(() => {
                if (this.intervalResendCode > 0) {
                    this.intervalResendCode--;
                } else {
                    clearInterval(interval);
                }
            }, 1000);
        },
        resendCode() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner
                ? DibbleApi.api.accountChangeFactorReSendOtpCode
                : DibbleApi.api.managedUserChangeFactorReSendOtpCode,
                second_factor_key: this.data.second_factor_key,
                factor_type: this.verify_type.toUpperCase(),
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    DibbleJs.toastSuccessMessage(
                        'Verification code sent successfully'
                    );

                    this.otpCode = {
                        1: '',
                        2: '',
                        3: '',
                        4: '',
                        5: '',
                        6: '',
                    };
                    this.$refs.otp1.focus();
                    this.startResendCodeInterval();
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        performVerificationOtp() {
            const code = [];
            for (let i = 1; i <= 6; i++) {
                code.push(this.otpCode[i]);
            }

            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner
                    ? DibbleApi.api.accountChangeFactorVerifyOtpCode
                    : DibbleApi.api.managedUserChangeFactorVerifyOtpCode
                ,
                second_factor_key: this.data.second_factor_key,
                factor_type: this.verify_type.toUpperCase(),
                verification_code: code.join(''),
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    this.isSuccess = true;
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        handleKeyDown(event, index) {
            if (event.key === 'Backspace') {
                this.otpCode[index] = ''

                if (index > 1) {
                    this.$refs[`otp${index - 1}`].focus()
                }

                return
            }

            if (!this.otpCode[index])
                return

            if (event.key !== 'Tab'
                && event.key !== 'ArrowRight'
                && event.key !== 'ArrowLeft'
            )
                event.preventDefault()

            if ((/^([0-9])$/).test(event.key)) {
                if (index !== 6)
                    this.$refs[`otp${index + 1}`].focus()
            }
        },
        _onRequestFailed(error) {
            this.isLoadingData = false
            DibbleJS.hideLoader();
            console.log(error)
            this.closeModal()
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #ecf5f7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.form-box.otp-input-wrap {
    box-shadow: 0px 12px 20px -16px #767676;
    /* -webkit-box-shadow: 0px 12px 20px -12px #767676; */
    -moz-box-shadow: -1px 7px 5px -2px rgba(191, 191, 191, 0.75);
    background: #e8eff1;
    padding-top: 14px;
}

.otp-input {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;
            cursor: pointer;

            &.active:after {
                display: block;
            }

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
</style>
